/**
 * Status display metadata (tokens.json color.status.*). Maps each lifecycle status to its token
 * CSS-var suffix (for the pill/dot) and the resident-facing plain-language line (tracking/spec §4).
 * The status VALUES are the @td/shared enum; labels come from REQUEST_STATUS_LABELS.
 */
import { REQUEST_STATUS_LABELS, type RequestStatus } from "@td/shared";

/** token key in tokens.json color.status.* — drives --td-status-<key>-fg/bg/dot. */
const STATUS_TOKEN: Record<RequestStatus, string> = {
  New: "new",
  Acknowledged: "acknowledged",
  InProgress: "inprogress",
  Resolved: "resolved",
  Closed: "closed",
  Duplicate: "duplicate",
  Invalid: "rejected",
};

/** Resident-facing plain-language line under the pill (tracking/spec §4). */
export const STATUS_RESIDENT_LINE: Record<RequestStatus, string> = {
  New: "Received. Waiting for a staff member to review.",
  Acknowledged: "A staff member has seen this and it's in the queue.",
  InProgress: "Someone is working on this now.",
  Resolved: "This has been resolved. See the note below.",
  Closed: "This concern is closed.",
  Duplicate: "This matches another report we're already handling.",
  Invalid: "We reviewed this and won't be acting on it.",
};

export function statusLabel(s: RequestStatus): string {
  return REQUEST_STATUS_LABELS[s];
}

export function statusToken(s: RequestStatus): string {
  return STATUS_TOKEN[s];
}
